var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDossiers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "-2 -2 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C1.01625 0 0 1.01625 0 2.25V13.75C0 14.9838 1.01625 16 2.25 16H17.75C18.9838 16 20 14.9838 20 13.75V4.75C20 3.51625 18.9838 2.5 17.75 2.5H10.0215L7.78613 0.637695C7.29203 0.226055 6.66958 0 6.02637 0H2.25ZM2.25 1.5H6.02637C6.31915 1.5 6.60128 1.60268 6.82617 1.79004L8.57812 3.25L6.82617 4.70996C6.60128 4.89732 6.31915 5 6.02637 5H1.5V2.25C1.5 1.82675 1.82675 1.5 2.25 1.5ZM10.0215 4H17.75C18.1733 4 18.5 4.32675 18.5 4.75V13.75C18.5 14.1732 18.1733 14.5 17.75 14.5H2.25C1.82675 14.5 1.5 14.1732 1.5 13.75V6.5H6.02637C6.66958 6.5 7.29203 6.27394 7.78613 5.8623L10.0215 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDossiers);
export default __webpack_public_path__ + "static/media/sidebar-dossiers.33cd596f1eaa1122d9a794a3d0b3fd03.svg";
export { ForwardRef as ReactComponent };